import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { TableRow, TableHeader, Table, TableHeaderColumn, TableBody, TableRowColumn, Checkbox, Avatar, MenuItem } from 'material-ui';
import R, { ifElse, not, isNil, isEmpty, either, contains } from 'ramda';
import { checkConnection, uncheckConnection } from '../../../../../stores/contracting/send-to-partners/actions';
import FlatDropDownMenu from '../../../../tc-ui/flatDropDownMenu';
import ArrowDropDownIcon from 'material-ui/svg-icons/navigation/arrow-drop-down';
import { SmallFlatButton } from '../../../../tc-ui/small-buttons';

const isNilOrEmpty = either(isNil, isEmpty);

const TableContainer = props => {
  const {
    updateProps,
    sendToPartners,
    check,
    uncheck,
  } = props;
  const { filteredConnections, searchField, selectedTag, selectedExistingPartners, existingConnections } = sendToPartners;
  const partnersToShow = (not(isNilOrEmpty(filteredConnections)) || searchField || selectedTag ? filteredConnections : existingConnections);
  const selectAllCheck = (selectedExistingPartners.length > 0) && (selectedExistingPartners.length === partnersToShow.length);
  const tags = R.call(R.compose(
    R.uniq,
    R.chain(R.propOr([], 'tags'))
  ), existingConnections);
  return (
    <div>
      <Table selectable={false} style={{ borderBottom: '1px solid #e0e0e0' }}>
        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
          <TableRow>
            <TableHeaderColumn colSpan="1">
              <Checkbox
                onCheck={ifElse(
                  () => selectAllCheck,
                  () => uncheck({ checkType: 'uncheckAll' }),
                  () => check({ checkType: 'checkAll' })
                )}
                checked={selectAllCheck}
              />
            </TableHeaderColumn>
            <TableHeaderColumn colSpan="1" />
            <TableHeaderColumn colSpan="5">Company Name</TableHeaderColumn>
            <TableHeaderColumn colSpan="5">Email</TableHeaderColumn>
            <TableHeaderColumn colSpan="3" style={{ padding: 0 }}>
              <FlatDropDownMenu
                button={<SmallFlatButton label={selectedTag ? `Tag: ${selectedTag}` : 'Tags'} labelStyle={{ color: 'rgba(0, 0, 0, 0.34)', fontSize: '12px', top: '0px' }} icon={<ArrowDropDownIcon/>} labelPosition="before" />}
              >
                {
                  tags.map((tag, i) => {
                    return (
                      <MenuItem
                        key={i}
                        value={tag}
                        primaryText={tag}
                        checked={selectedTag === tag}
                        onTouchTap={() => updateProps({
                          selectedTag: selectedTag === tag ? undefined : tag,
                          filteredConnections: existingConnections.filter(partner => {
                            const textSearch = searchField ? (partner.companyName && contains(searchField.toLowerCase(), partner.companyName.toLowerCase())) ||
                              (partner.email && partner.email !== 'via TourConnect' && contains(searchField.toLowerCase(), partner.email.toLowerCase())) : true;
                            const tagSearch = selectedTag !== tag ? contains(tag, partner.tags) : true;
                            return textSearch && tagSearch;
                          }),
                        })}
                      />
                    );
                  })
                }
              </FlatDropDownMenu>
            </TableHeaderColumn>
          </TableRow>
        </TableHeader>
        <TableBody displayRowCheckbox={false}>
          {
            // the filter is reduce the amount of initial rendering
            partnersToShow.filter((_, i) => (partnersToShow.length < 81 || sendToPartners.showAllExisting) || i < 81)
              .map((partner, i) => (
                <TableRow key={i} style={{ height: '32px' }}>
                  <TableRowColumn colSpan="1">
                    <Checkbox
                      onCheck={ifElse(
                        () => contains(partner, sendToPartners.selectedExistingPartners),
                        () => uncheck({ checkType: 'uncheckOne', partner }),
                        () => check({ checkType: 'checkOne', partner })
                      )}
                      checked={contains(partner, sendToPartners.selectedExistingPartners)}
                    />
                  </TableRowColumn>
                  <TableRowColumn style={{ height: '32px', fontSize: '14px', textAlign: 'center', padding: 0 }} colSpan="1">
                    {
                      partner.profileImageUrl ? <Avatar src={partner.profileImageUrl}/> : <Avatar>{R.head(partner.companyId ? partner.companyName : partner.email)}</Avatar>
                    }
                  </TableRowColumn>
                  <TableRowColumn style={{ height: '32px', fontSize: '14px' }} colSpan="5">
                    {partner.companyName}
                  </TableRowColumn>
                  <TableRowColumn style={{ height: '32px', fontSize: '14px' }} colSpan="5">
                    {partner.email}
                  </TableRowColumn>
                  <TableRowColumn style={{ fontSize: '14px', padding: 0, whiteSpace: 'pre-wrap' }} colSpan="3">
                    {partner.tags.join(', ')}
                  </TableRowColumn>
                </TableRow>
              ))
          }
        </TableBody>
      </Table>
      {
        partnersToShow && partnersToShow.length > 80 ? (
          <div
            style={{ lineHeight: '48px', color: '#00bcd4', cursor: 'pointer' }}
            onClick={() => updateProps({ showAllExisting: !sendToPartners.showAllExisting })}
          >
            {sendToPartners.showAllExisting ? 'Show Less' : 'Show All'}
          </div>
        ) : <div/>
      }
    </div>
  );
};

TableContainer.propTypes = {
  sendToPartners: PropTypes.object,
  check: PropTypes.func,
  uncheck: PropTypes.func,
  updateProps: PropTypes.func,
};

const mapDispatchToProps = dispatch => ({
  check: (...args) => dispatch(checkConnection(...args)),
  uncheck: (...args) => dispatch(uncheckConnection(...args)),
});

const mapStateToProps = ({ contracting }) => ({
  sendToPartners: contracting.sendToPartners.toJS(),
});

export default connect(mapStateToProps, mapDispatchToProps)(TableContainer);



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/send-to-partners/existing/table.jsx